import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { createDarkTheme, createLightTheme } from './assets/themes/myTheme';
import { useSettings } from './context/SettingsContext'; // Assuming you have a hook to access settings
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { deDE } from '@mui/x-date-pickers/locales';
import { enUS } from '@mui/x-date-pickers/locales';
import { frFR } from '@mui/x-date-pickers/locales';
import { esES } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';


const ThemeWrapper: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { darkMode, language } = useSettings();

  const getLocale = (language: string) => {
    switch (language) {
      case 'de':
        return deDE;
      case 'en':
        return enUS;
      case 'fr':
        return frFR;
      case 'es':
        return esES;
      default:
        return enUS;
    }
  };

  const getLocaleDayjs = (language: string) => {
    switch (language) {
      case 'de':
        return 'de';
      case 'en':
        return 'en';
      case 'fr':
        return 'fr';
      case 'es':
        return 'es';
      default:
        return 'en';
    }
  }

  const getLocaleText = (language: string) => {
    switch (language) {
      case 'de':
        return deDE.components.MuiLocalizationProvider.defaultProps.localeText;
      case 'en':
        return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
      case 'fr':
        return frFR.components.MuiLocalizationProvider.defaultProps.localeText;
      case 'es':
        return esES.components.MuiLocalizationProvider.defaultProps.localeText;
      default:
        return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
    }
  }

  const locale = getLocale(language);
  const theme = darkMode ? createDarkTheme(locale) : createLightTheme(locale);

  return (
    <LocalizationProvider 
      dateAdapter={AdapterDayjs} 
      localeText={getLocaleText(language)}
      adapterLocale={getLocaleDayjs(language)}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default ThemeWrapper;